<template>
  <div class="container">
    <div class="catalog">
      <button @click="bioPage">Biyografi</button>
      <button @click="personalExhibition">Kişisel Sergi</button>
      <button @click="groupExhibition">Karma Sergi</button>
      <button @click="symposium">Sempozyum</button>
      <button @click="fair">Fuar</button>
      <button @click="award">Ödül</button>
      <button @click="artisticPerspective">Sanat Anlayışı</button>
      <button @click="artInterpretation">Sanat Görüşü</button>
    </div>

    <div class="bio">
      <table>
          <tbody>
            <tr>
              <td>Biyografi (EN): </td>
              <td>
                  <textarea name="bio_EN" id="exhibitionInfo_EN" cols="80" rows="10" v-model="biographyData.biographyEN">
                  </textarea>
              </td>
            </tr>
            <tr>
              <td>Biyografi (TR): </td>
              <td>
                  <textarea name="bio_TR" id="exhibitionInfo_TR" cols="80" rows="10" v-model="biographyData.biographyTR">
                  </textarea>
              </td>
            </tr>
            <tr>
              <td></td>
              <td><button class="updateBio saveBtn" @click="updateBio">Kaydet</button></td>
            </tr>
          </tbody>
      </table>
    </div>
    <div class="personal-exhibition" style="display: none;">
      <div style="display: flex; justify-content: flex-start;">
        <button style="margin-left: 20px; background-color: #218838; color: aliceblue;" @click="openPersonalExhibitionaddModal">Yeni kayıt</button>
        <button style="margin-left: 20px; background-color: #0069D9; color: aliceblue;" @click="savePersonalExhibitionOrder">Sıralamayı kaydet</button>
      </div>
      
      <draggableComponent
        v-model="achievementData.personalExhibitions"
        id="personal-exhibition-list"
        @start="drag=true" 
        @end="onDragEndPersonalExhibition"
        tag="div"
        item-key="orderNo"
      >
          <template #item="{element: personalExhibition}">
              <div class="image-item">
                  <div class="image-name">
                      {{ personalExhibition.year }}
                      {{ personalExhibition.textTR }}
                  </div>
                  <div class="image-button-group">
                      <div class="image-info">
                          <button @click="openPersonalExhibitionInfoModal(personalExhibition.orderNo)">Detay</button>
                      </div>
                      <div class="delete">
                          <button @click="openPersonalExhibitionDeleteModal(personalExhibition.orderNo)">Sil</button>
                      </div>
                  </div>
              </div>
          </template>
      </draggableComponent>

      <!--PERSONAL EXHIBITION ADD MODAL-->
      <div
        v-if="isPersonalExhibitionAddVisible"
        class="add-modal-overlay"
      >
        <div class="add-modal-content">
          <table>
            <tbody>
              <tr>
                  <td>Yıl: </td>
                  <td>
                    <textarea name="year" id="year" cols="10" rows="1" v-model="personalExhibitionToBeChanged.year">
                      </textarea>
                  </td>
              </tr>
              <tr>
                  <td>Sergi Bilgisi (EN): </td>
                  <td>
                      <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="personalExhibitionToBeChanged.textEN">
                      </textarea>
                  </td>
              </tr>
              <tr>
                  <td>Sergi Bilgisi (TR): </td>
                  <td>
                      <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="personalExhibitionToBeChanged.textTR">
                      </textarea>
                  </td>
              </tr>
            </tbody>
          </table>
          <div class="add-modal-actions">
                <button @click="addPersonalExhibition">Ekle</button>
                <button @click="closePersonalExhibitionaddModal">Vazgeç</button>
            </div>
        </div>
      </div>

      <!--PERSONAL EXHIBITION DETAILS MODAL-->
      <div
        id="detail-modal-container" 
        v-if="isPersonalExhibitionDetailVisible"
        class="detail-modal-overlay"
      >
        <div class="detail-modal-content">
            <table>
                <tbody>
                    <tr>
                        <td>Yıl: </td>
                        <td>
                          <textarea name="year" id="year" cols="10" rows="1" v-model="personalExhibitionToBeChanged.year">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi Bilgisi (EN): </td>
                        <td>
                            <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="personalExhibitionToBeChanged.textEN">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi Bilgisi (TR): </td>
                        <td>
                            <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="personalExhibitionToBeChanged.textTR">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi sırası: </td>
                        <td>{{ personalExhibitionToBeChanged.orderNo }}</td>
                    </tr>
                </tbody>
            </table>
            <p>Sergi bilgileri değiştirilecektir. Bu işlem geri alınamaz.</p>
            <div class="detail-modal-actions">
                <button @click="updatePersonalExhibitionInfo">Onayla</button>
                <button @click="closePersonalExhibitionDetailModal">İptal</button>
            </div>
        </div>
      </div>

      <!--PERSONAL EXHIBITION DELETE MODAL-->
      <div 
        id="modal-container" 
        v-if="isPersonalExhibitionDeleteConfimationVisible"
        class="modal-overlay"
      >
        <div class="modal-content">
            <h2>Emin misiniz?</h2>
            <p>Gerçekten silmek istiyor musunuz? Bu işlem geri alınamaz.</p>
            <div class="modal-actions">
                <button @click="handleDeletePersonalExhibition()">Evet</button>
                <button @click="closePersonalExhibitionDeleteModal()">Hayır</button>
            </div>
        </div>
        
      </div>
    </div>
    <div class="group-exhibition" style="display: none;">
    
      <div style="display: flex; justify-content: flex-start;">
        <button style="margin-left: 20px; background-color: #218838; color: aliceblue;" @click="openGroupExhibitionaddModal">Yeni kayıt</button>
        <button style="margin-left: 20px; background-color: #0069D9; color: aliceblue;" @click="saveGroupExhibitionOrder">Sıralamayı kaydet</button>
      </div>
    
      <draggableComponent
        v-model="achievementData.selectedGroupExhibitions"
        id="group-exhibition-list"
        @start="drag=true" 
        @end="onDragEndGroupExhibition"
        tag="div"
        item-key="orderNo"
      >
          <template #item="{element: groupExhibition}">
              <div class="image-item">
                  <div class="image-name">
                      {{ groupExhibition.year }}
                      {{ groupExhibition.textTR }}
                  </div>
                  <div class="image-button-group">
                      <div class="image-info">
                          <button @click="openGroupExhibitionInfoModal(groupExhibition.orderNo)">Detay</button>
                      </div>
                      <div class="delete">
                          <button @click="openGroupExhibitionDeleteModal(groupExhibition.orderNo)">Sil</button>
                      </div>
                  </div>
              </div>
          </template>
      </draggableComponent>

      <!--GROUP EXHIBITION ADD MODAL-->
      <div
        v-if="isGroupExhibitionAddVisible"
        class="add-modal-overlay"
      >
        <div class="add-modal-content">
          <table>
            <tbody>
              <tr>
                  <td>Yıl: </td>
                  <td>
                    <textarea name="year" id="year" cols="10" rows="1" v-model="groupExhibitionToBeChanged.year">
                      </textarea>
                  </td>
              </tr>
              <tr>
                  <td>Sergi Bilgisi (EN): </td>
                  <td>
                      <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="groupExhibitionToBeChanged.textEN">
                      </textarea>
                  </td>
              </tr>
              <tr>
                  <td>Sergi Bilgisi (TR): </td>
                  <td>
                      <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="groupExhibitionToBeChanged.textTR">
                      </textarea>
                  </td>
              </tr>
            </tbody>
          </table>
          <div class="add-modal-actions">
                <button @click="addGroupExhibition">Ekle</button>
                <button @click="closeGroupExhibitionaddModal">Vazgeç</button>
            </div>
        </div>
      </div>

      <!--GROUP EXHIBITION DETAILS MODAL-->
      <div
        id="group-detail-modal-container" 
        v-if="isGroupExhibitionDetailVisible"
        class="detail-modal-overlay"
      >
        <div class="detail-modal-content">
            <table>
                <tbody>
                    <tr>
                        <td>Yıl: </td>
                        <td>
                          <textarea name="year" id="year" cols="10" rows="1" v-model="groupExhibitionToBeChanged.year">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi Bilgisi (EN): </td>
                        <td>
                            <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="groupExhibitionToBeChanged.textEN">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi Bilgisi (TR): </td>
                        <td>
                            <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="groupExhibitionToBeChanged.textTR">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi sırası: </td>
                        <td>{{ groupExhibitionToBeChanged.orderNo }}</td>
                    </tr>
                </tbody>
            </table>
            <p>Sergi bilgileri değiştirilecektir. Bu işlem geri alınamaz.</p>
            <div class="detail-modal-actions">
                <button @click="updateGroupExhibitionInfo">Onayla</button>
                <button @click="closeGroupExhibitionDetailModal">İptal</button>
            </div>
        </div>
      </div>

      <!--GROUP EXHIBITION DELETE MODAL-->
      <div 
        id="group-modal-container" 
        v-if="isGroupExhibitionDeleteConfimationVisible"
        class="modal-overlay"
      >
        <div class="modal-content">
            <h2>Emin misiniz?</h2>
            <p>Gerçekten silmek istiyor musunuz? Bu işlem geri alınamaz.</p>
            <div class="modal-actions">
                <button @click="handleDeleteGroupExhibition()">Evet</button>
                <button @click="closeGroupExhibitionDeleteModal()">Hayır</button>
            </div>
        </div>
        
      </div>
    
    </div>
    <div class="symposium" style="display: none;">
      <div style="display: flex; justify-content: flex-start;">
        <button style="margin-left: 20px; background-color: #218838; color: aliceblue;" @click="openSymposiumaddModal">Yeni kayıt</button>
        <button style="margin-left: 20px; background-color: #0069D9; color: aliceblue;" @click="saveSymposiumOrder">Sıralamayı kaydet</button>
      </div>

      <draggableComponent
        v-model="achievementData.symposiums"
        id="symposium-list"
        @start="drag=true" 
        @end="onDragEndSymposium"
        tag="div"
        item-key="orderNo"
      >
          <template #item="{element: symposium}">
              <div class="image-item">
                  <div class="image-name">
                      {{ symposium.year }}
                      {{ symposium.textTR }}
                  </div>
                  <div class="image-button-group">
                      <div class="image-info">
                          <button @click="openSymposiumInfoModal(symposium.orderNo)">Detay</button>
                      </div>
                      <div class="delete">
                          <button @click="openSymposiumDeleteModal(symposium.orderNo)">Sil</button>
                      </div>
                  </div>
              </div>
          </template>
      </draggableComponent>

      <!--SYMPOSİUM ADD MODAL-->
      <div
        v-if="isSymposiumAddVisible"
        class="add-modal-overlay"
      >
        <div class="add-modal-content">
          <table>
            <tbody>
              <tr>
                  <td>Yıl: </td>
                  <td>
                    <textarea name="year" id="year" cols="10" rows="1" v-model="symposiumToBeChanged.year">
                      </textarea>
                  </td>
              </tr>
              <tr>
                  <td>Sergi Bilgisi (EN): </td>
                  <td>
                      <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="symposiumToBeChanged.textEN">
                      </textarea>
                  </td>
              </tr>
              <tr>
                  <td>Sergi Bilgisi (TR): </td>
                  <td>
                      <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="symposiumToBeChanged.textTR">
                      </textarea>
                  </td>
              </tr>
            </tbody>
          </table>
          <div class="add-modal-actions">
                <button @click="addSymposium">Ekle</button>
                <button @click="closeSymposiumaddModal">Vazgeç</button>
            </div>
        </div>
      </div>

      <!--SYMPOSİUM DETAILS MODAL-->
      <div
        id="symposium-detail-modal-container" 
        v-if="isSymposiumDetailVisible"
        class="detail-modal-overlay"
      >
        <div class="detail-modal-content">
            <table>
                <tbody>
                    <tr>
                        <td>Yıl: </td>
                        <td>
                          <textarea name="year" id="year" cols="10" rows="1" v-model="symposiumToBeChanged.year">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi Bilgisi (EN): </td>
                        <td>
                            <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="symposiumToBeChanged.textEN">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi Bilgisi (TR): </td>
                        <td>
                            <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="symposiumToBeChanged.textTR">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi sırası: </td>
                        <td>{{ symposiumToBeChanged.orderNo }}</td>
                    </tr>
                </tbody>
            </table>
            <p>Sergi bilgileri değiştirilecektir. Bu işlem geri alınamaz.</p>
            <div class="detail-modal-actions">
                <button @click="updateSymposiumInfo">Onayla</button>
                <button @click="closeSymposiumDetailModal">İptal</button>
            </div>
        </div>
      </div>

      <!--SYMPOSİUM DELETE MODAL-->
      <div 
        id="symposium-modal-container" 
        v-if="isSymposiumDeleteConfimationVisible"
        class="modal-overlay"
      >
        <div class="modal-content">
            <h2>Emin misiniz?</h2>
            <p>Gerçekten silmek istiyor musunuz? Bu işlem geri alınamaz.</p>
            <div class="modal-actions">
                <button @click="handleDeleteSymposium()">Evet</button>
                <button @click="closeSymposiumDeleteModal()">Hayır</button>
            </div>
        </div>
        
      </div>

    </div>  
    <div class="fair" style="display: none;">
      <div style="display: flex; justify-content: flex-start;">
        <button style="margin-left: 20px; background-color: #218838; color: aliceblue;" @click="openFairaddModal">Yeni kayıt</button>
        <button style="margin-left: 20px; background-color: #0069D9; color: aliceblue;" @click="saveFairOrder">Sıralamayı kaydet</button>
      </div>

        <draggableComponent
        v-model="achievementData.fairs"
        id="fair-list"
        @start="drag=true" 
        @end="onDragEndFair"
        tag="div"
        item-key="orderNo"
      >
          <template #item="{element: fair}">
              <div class="image-item">
                  <div class="image-name">
                      {{ fair.year }}
                      {{ fair.textTR }}
                  </div>
                  <div class="image-button-group">
                      <div class="image-info">
                          <button @click="openFairInfoModal(fair.orderNo)">Detay</button>
                      </div>
                      <div class="delete">
                          <button @click="openFairDeleteModal(fair.orderNo)">Sil</button>
                      </div>
                  </div>
              </div>
          </template>
      </draggableComponent>

        <!--FAIR ADD MODAL-->
        <div
          v-if="isFairAddVisible"
          class="add-modal-overlay"
        >
          <div class="add-modal-content">
            <table>
              <tbody>
                <tr>
                    <td>Yıl: </td>
                    <td>
                      <textarea name="year" id="year" cols="10" rows="1" v-model="fairToBeChanged.year">
                        </textarea>
                    </td>
                </tr>
                <tr>
                    <td>Sergi Bilgisi (EN): </td>
                    <td>
                        <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="fairToBeChanged.textEN">
                        </textarea>
                    </td>
                </tr>
                <tr>
                    <td>Sergi Bilgisi (TR): </td>
                    <td>
                        <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="fairToBeChanged.textTR">
                        </textarea>
                    </td>
                </tr>
              </tbody>
            </table>
            <div class="add-modal-actions">
                  <button @click="addFair">Ekle</button>
                  <button @click="closeFairaddModal">Vazgeç</button>
              </div>
          </div>
        </div>

        <!--FAIR DETAILS MODAL-->
        <div
          id="fair-detail-modal-container" 
          v-if="isFairDetailVisible"
          class="detail-modal-overlay"
        >
          <div class="detail-modal-content">
              <table>
                  <tbody>
                      <tr>
                          <td>Yıl: </td>
                          <td>
                            <textarea name="year" id="year" cols="10" rows="1" v-model="fairToBeChanged.year">
                              </textarea>
                          </td>
                      </tr>
                      <tr>
                          <td>Sergi Bilgisi (EN): </td>
                          <td>
                              <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="fairToBeChanged.textEN">
                              </textarea>
                          </td>
                      </tr>
                      <tr>
                          <td>Sergi Bilgisi (TR): </td>
                          <td>
                              <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="fairToBeChanged.textTR">
                              </textarea>
                          </td>
                      </tr>
                      <tr>
                          <td>Sergi sırası: </td>
                          <td>{{ fairToBeChanged.orderNo }}</td>
                      </tr>
                  </tbody>
              </table>
              <p>Sergi bilgileri değiştirilecektir. Bu işlem geri alınamaz.</p>
              <div class="detail-modal-actions">
                  <button @click="updateFairInfo">Onayla</button>
                  <button @click="closeFairDetailModal">İptal</button>
              </div>
          </div>
        </div>

        <!--FAIR DELETE MODAL-->
        <div 
          id="fair-modal-container" 
          v-if="isFairDeleteConfimationVisible"
          class="modal-overlay"
        >
          <div class="modal-content">
              <h2>Emin misiniz?</h2>
              <p>Gerçekten silmek istiyor musunuz? Bu işlem geri alınamaz.</p>
              <div class="modal-actions">
                  <button @click="handleDeleteFair()">Evet</button>
                  <button @click="closeFairDeleteModal()">Hayır</button>
              </div>
          </div>
          
        </div>
    </div>
    <div class="award" style="display: none;">
      <div style="display: flex; justify-content: flex-start;">
        <button style="margin-left: 20px; background-color: #218838; color: aliceblue;" @click="openPrizeaddModal">Yeni kayıt</button>
        <button style="margin-left: 20px; background-color: #0069D9; color: aliceblue;" @click="savePrizeOrder">Sıralamayı kaydet</button>
      </div>

      <draggableComponent
        v-model="achievementData.prizes"
        id="prize-list"
        @start="drag=true" 
        @end="onDragEndPrize"
        tag="div"
        item-key="orderNo"
      >
          <template #item="{element: prize}">
              <div class="image-item">
                  <div class="image-name">
                      {{ prize.year }}
                      {{ prize.textTR }}
                  </div>
                  <div class="image-button-group">
                      <div class="image-info">
                          <button @click="openPrizeInfoModal(prize.orderNo)">Detay</button>
                      </div>
                      <div class="delete">
                          <button @click="openPrizeDeleteModal(prize.orderNo)">Sil</button>
                      </div>
                  </div>
              </div>
          </template>
      </draggableComponent>

      <!--PRIZE ADD MODAL-->
        <div
          v-if="isPrizeAddVisible"
          class="add-modal-overlay"
        >
          <div class="add-modal-content">
            <table>
              <tbody>
                <tr>
                    <td>Yıl: </td>
                    <td>
                      <textarea name="year" id="year" cols="10" rows="1" v-model="prizeToBeChanged.year">
                        </textarea>
                    </td>
                </tr>
                <tr>
                    <td>Sergi Bilgisi (EN): </td>
                    <td>
                        <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="prizeToBeChanged.textEN">
                        </textarea>
                    </td>
                </tr>
                <tr>
                    <td>Sergi Bilgisi (TR): </td>
                    <td>
                        <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="prizeToBeChanged.textTR">
                        </textarea>
                    </td>
                </tr>
              </tbody>
            </table>
            <div class="add-modal-actions">
                  <button @click="addPrize">Ekle</button>
                  <button @click="closePrizeaddModal">Vazgeç</button>
              </div>
          </div>
        </div>

      <!--PRIZE DETAILS MODAL-->
        <div
          id="prize-detail-modal-container" 
          v-if="isPrizeDetailVisible"
          class="detail-modal-overlay"
        >
          <div class="detail-modal-content">
              <table>
                  <tbody>
                      <tr>
                          <td>Yıl: </td>
                          <td>
                            <textarea name="year" id="year" cols="10" rows="1" v-model="prizeToBeChanged.year">
                              </textarea>
                          </td>
                      </tr>
                      <tr>
                          <td>Sergi Bilgisi (EN): </td>
                          <td>
                              <textarea name="textEN" id="textEN" cols="30" rows="5" v-model="prizeToBeChanged.textEN">
                              </textarea>
                          </td>
                      </tr>
                      <tr>
                          <td>Sergi Bilgisi (TR): </td>
                          <td>
                              <textarea name="textTR" id="textTR" cols="30" rows="5" v-model="prizeToBeChanged.textTR">
                              </textarea>
                          </td>
                      </tr>
                      <tr>
                          <td>Sergi sırası: </td>
                          <td>{{ prizeToBeChanged.orderNo }}</td>
                      </tr>
                  </tbody>
              </table>
              <p>Sergi bilgileri değiştirilecektir. Bu işlem geri alınamaz.</p>
              <div class="detail-modal-actions">
                  <button @click="updatePrizeInfo">Onayla</button>
                  <button @click="closePrizeDetailModal">İptal</button>
              </div>
          </div>
        </div>

      <!--PRIZE DELETE MODAL-->
        <div 
          id="prize-modal-container" 
          v-if="isPrizeDeleteConfimationVisible"
          class="modal-overlay"
        >
          <div class="modal-content">
              <h2>Emin misiniz?</h2>
              <p>Gerçekten silmek istiyor musunuz? Bu işlem geri alınamaz.</p>
              <div class="modal-actions">
                  <button @click="handleDeletePrize()">Evet</button>
                  <button @click="closePrizeDeleteModal()">Hayır</button>
              </div>
          </div>
          
        </div>

    </div>
    <div class="artistic-perspective bio" style="display: none;">
      <table>
          <tbody>
            <tr>
              <td>Sanat Anlayışı (EN): </td>
              <td>
                  <textarea name="bio_EN" id="exhibitionInfo_EN" cols="80" rows="10" v-model="biographyData.artPerspectiveEN">
                  </textarea>
              </td>
            </tr>
            <tr>
              <td>Sanat Anlayışı (TR): </td>
              <td>
                  <textarea name="bio_TR" id="exhibitionInfo_TR" cols="80" rows="10" v-model="biographyData.artPerspectiveTR">
                  </textarea>
              </td>
            </tr>
            <tr>
              <td></td>
              <td><button class="updateBio saveBtn" @click="updateBio">Kaydet</button></td>
            </tr>
          </tbody>
      </table>
    </div>
    <div class="art-interpretation bio" style="display: none;">
      <table>
          <tbody>
            <tr>
              <td>Sanat Görüşü (EN): </td>
              <td>
                  <textarea name="bio_EN" id="exhibitionInfo_EN" cols="80" rows="10" v-model="biographyData.artInterPretationEN">
                  </textarea>
              </td>
            </tr>
            <tr>
              <td>Sanat Görüşü (TR): </td>
              <td>
                  <textarea name="bio_TR" id="exhibitionInfo_TR" cols="80" rows="10" v-model="biographyData.artInterPretationTR">
                  </textarea>
              </td>
            </tr>
            <tr>
              <td></td>
              <td><button class="updateBio saveBtn" @click="updateBio">Kaydet</button></td>
            </tr>
          </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import draggableComponent from 'vuedraggable';
import axios from 'axios';

export default {
  data(){
    return{
      biographyData: {
        biographyTR: "",
        biographyEN: "",
        artPerspectiveTR: "",
        artPerspectiveEN: "",
        artInterPretationTR: "",
        artInterPretationEN: ""
      },
      achievementData: {
        personalExhibitions: [],
        selectedGroupExhibitions: [],
        symposiums: [],
        fairs: [],
        prizes: []
      },

      //PersonalExhibition
      isPersonalExhibitionAddVisible:false,
      isPersonalExhibitionDeleteConfimationVisible: false,
      isPersonalExhibitionDetailVisible:false,
      personalExhibitionOrderNoToBeDeleted: 0,
      personalExhibitionToBeChanged: {},

      //GroupExhibition
      isGroupExhibitionAddVisible:false,
      isGroupExhibitionDeleteConfimationVisible: false,
      isGroupExhibitionDetailVisible:false,
      groupExhibitionOrderNoToBeDeleted: 0,
      groupExhibitionToBeChanged: {},

      //Symposium
      isSymposiumAddVisible:false,
      isSymposiumDeleteConfimationVisible: false,
      isSymposiumDetailVisible:false,
      symposiumOrderNoToBeDeleted: 0,
      symposiumToBeChanged: {},

      //Fair
      isFairAddVisible:false,
      isFairDeleteConfimationVisible: false,
      isFairDetailVisible:false,
      fairOrderNoToBeDeleted: 0,
      fairToBeChanged: {},

      //Prize
      isPrizeAddVisible:false,
      isPrizeDeleteConfimationVisible: false,
      isPrizeDetailVisible:false,
      prizeOrderNoToBeDeleted: 0,
      prizeToBeChanged: {},
    };
  },

  async created(){
    const biographyResponse = await axios.get('/api-path/Biography/get-bio');
    const achievementResponse = await axios.get('/api-path/Biography/get-achievements');
    this.biographyData = biographyResponse.data;
    this.achievementData = achievementResponse.data;
  },

  components: {
        draggableComponent: draggableComponent,
  },

  methods:{
    //OnDrag
    onDragEndPersonalExhibition() {
      this.achievementData.personalExhibitions.forEach((item, index) => {
        item.orderNo = index + 1;
      });
      this.drag = false;
    },
    onDragEndGroupExhibition(){
      this.achievementData.selectedGroupExhibitions.forEach((item, index) => {
        item.orderNo = index + 1;
      });
      this.drag = false;
    },
    onDragEndSymposium(){
      this.achievementData.symposiums.forEach((item, index) => {
        item.orderNo = index + 1;
      });
      this.drag = false;
    },
    onDragEndFair(){
      this.achievementData.fairs.forEach((item, index) => {
        item.orderNo = index + 1;
      });
      this.drag = false;
    },
    onDragEndPrize(){
      this.achievementData.prizes.forEach((item, index) => {
        item.orderNo = index + 1;
      });
      this.drag = false;
    },

    //Edit sayfası görünürlüğü
    bioPage(){
      document.querySelector('.bio').style.display = 'block';
      const classes = ['personal-exhibition', 'group-exhibition', 'symposium', 'fair', 'award', 'artistic-perspective', 'art-interpretation'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },
    personalExhibition(){
      document.querySelector('.personal-exhibition').style.display = 'block';
      const classes = ['bio', 'group-exhibition', 'symposium', 'fair', 'award', 'artistic-perspective', 'art-interpretation'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },
    groupExhibition(){
      document.querySelector('.group-exhibition').style.display = 'block';
      const classes = ['bio', 'personal-exhibition', 'symposium', 'fair', 'award', 'artistic-perspective', 'art-interpretation'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },
    symposium(){
      document.querySelector('.symposium').style.display = 'block';
      const classes = ['bio', 'personal-exhibition', 'group-exhibition', 'fair', 'award', 'artistic-perspective', 'art-interpretation'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },
    fair(){
      document.querySelector('.fair').style.display = 'block';
      const classes = ['bio', 'personal-exhibition', 'group-exhibition', 'symposium', 'award', 'artistic-perspective', 'art-interpretation'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },
    award(){
      document.querySelector('.award').style.display = 'block';
      const classes = ['bio', 'personal-exhibition', 'group-exhibition', 'symposium', 'fair', 'artistic-perspective', 'art-interpretation'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },
    artisticPerspective(){
      document.querySelector('.artistic-perspective').style.display = 'block';
      const classes = ['bio', 'personal-exhibition', 'group-exhibition', 'symposium', 'fair', 'award', 'art-interpretation'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },
    artInterpretation(){
      document.querySelector('.art-interpretation').style.display = 'block';
      const classes = ['bio', 'personal-exhibition', 'group-exhibition', 'symposium', 'fair', 'award', 'artistic-perspective'];
      classes.forEach(cls => {
        const element = document.querySelector(`.${cls}`);
        if (element) {
          element.style.display = 'none';
        }
      });
    },

    //api call
    updateBio(){
      axios.put('/api-path/Biography/update-bio', this.biographyData)
        .then(() => {
          alert('Biyografi başarıyla güncellendi!');
        })
        .catch(error => {
          alert('Biyografi güncellenirken bir hata oluştu!\n'+ 'Hata: \n'+ error);
        });
    },
    updateAchievement(){
      axios.put('/api-path/Biography/update-achievements', this.achievementData)
        .then(() => {
          alert('Kariyer bilgisi başarıyla güncellendi!');
        })
        .catch(error => {
          alert('Kariyer bilgisi güncellenirken bir hata oluştu!\n'+ 'Hata: \n'+ error);
        });
    },

    //PersonalExhibition
    savePersonalExhibitionOrder(){
      this.updateAchievement();
    },
    openPersonalExhibitionaddModal(){
      this.isPersonalExhibitionAddVisible = true;
    },
    addPersonalExhibition(){
      // 1. orderNo 0 olarak ayarlanır
      this.personalExhibitionToBeChanged.orderNo = 0;

      // 2. Listeye en başa eklenir
      this.achievementData.personalExhibitions.unshift({ ...this.personalExhibitionToBeChanged });

      // 3. Tüm orderNo’lar 1'den başlayacak şekilde yeniden sıralanır
      this.achievementData.personalExhibitions.forEach((item, index) => {
        item.orderNo = index + 1;
      });

      //api call
      this.updateAchievement();
      this.closePersonalExhibitionaddModal();

    },
    closePersonalExhibitionaddModal(){
      this.isPersonalExhibitionAddVisible = false;
      this.personalExhibitionToBeChanged = {};
    },
    openPersonalExhibitionDeleteModal(orderNo) {
      this.isPersonalExhibitionDeleteConfimationVisible = true;
      this.personalExhibitionOrderNoToBeDeleted = orderNo;
    },
    closePersonalExhibitionDeleteModal(){
      this.isPersonalExhibitionDeleteConfimationVisible = false;
    },
    handleDeletePersonalExhibition(){
      //1. ilgili orderNo'ya sahip veriyi personalExhibition listesinden kaldır
      this.achievementData.personalExhibitions = this.achievementData.personalExhibitions.filter(
        item => item.orderNo !== this.personalExhibitionOrderNoToBeDeleted
      );

      //2. OrderNo'ya göre sırala
      this.achievementData.personalExhibitions = this.achievementData.personalExhibitions
        .sort((a, b) => a.orderNo - b.orderNo)
        .map((item, index) => ({
          ...item,
          orderNo: index + 1 // yeniden 1, 2, 3... diye numaralandır
        }));

      //3. update apisini çağır achievementData'yı gönder güncellensin
      this.updateAchievement();

      this.closePersonalExhibitionDeleteModal();
    },
    openPersonalExhibitionInfoModal(orderNo){
      this.personalExhibitionToBeChanged = this.achievementData.personalExhibitions.find(info => info.orderNo === orderNo);
      this.isPersonalExhibitionDetailVisible = true;
    },
    updatePersonalExhibitionInfo(){
      //this.personalExhibitionToBeChanged bunu this.achievementData.personalExhibitions içindeki değere geçir.
      const index = this.achievementData.personalExhibitions.findIndex(item => 
        item.orderNo === this.personalExhibitionToBeChanged.orderNo
      );

      if (index !== -1) {
        this.achievementData.personalExhibitions[index] = { ...this.personalExhibitionToBeChanged };
      }
      //api ile datayı güncelle
      this.updateAchievement();

      this.isPersonalExhibitionDetailVisible = false;
      this.personalExhibitionToBeChanged = {};
    },
    closePersonalExhibitionDetailModal(){
      this.isPersonalExhibitionDetailVisible = false;
      this.personalExhibitionToBeChanged = {};
    },

    //GroupExhibition
    openGroupExhibitionaddModal(){
      this.isGroupExhibitionAddVisible = true;
    },
    saveGroupExhibitionOrder(){
      this.updateAchievement();
    },
    openGroupExhibitionInfoModal(orderNo){
      this.groupExhibitionToBeChanged = this.achievementData.selectedGroupExhibitions.find(info => info.orderNo === orderNo);
      this.isGroupExhibitionDetailVisible = true;
    },
    closeGroupExhibitionDetailModal(){
      this.isGroupExhibitionDetailVisible = false;
      this.groupExhibitionToBeChanged = {};
    },
    openGroupExhibitionDeleteModal(orderNo){
      this.isGroupExhibitionDeleteConfimationVisible = true;
      this.groupExhibitionOrderNoToBeDeleted = orderNo;
    },
    addGroupExhibition(){
      // 1. orderNo 0 olarak ayarlanır
      this.groupExhibitionToBeChanged.orderNo = 0;

      // 2. Listeye en başa eklenir
      this.achievementData.selectedGroupExhibitions.unshift({ ...this.groupExhibitionToBeChanged });

      // 3. Tüm orderNo’lar 1'den başlayacak şekilde yeniden sıralanır
      this.achievementData.selectedGroupExhibitions.forEach((item, index) => {
        item.orderNo = index + 1;
      });

      //api call
      this.updateAchievement();
      this.closeGroupExhibitionaddModal();
    },
    closeGroupExhibitionaddModal(){
      this.isGroupExhibitionAddVisible = false;
      this.groupExhibitionToBeChanged = {};
    },
    updateGroupExhibitionInfo(){
      //this.groupExhibitionToBeChanged bunu this.achievementData.selectedGroupExhibitions içindeki değere geçir.
      const index = this.achievementData.selectedGroupExhibitions.findIndex(item => 
        item.orderNo === this.groupExhibitionToBeChanged.orderNo
      );

      if (index !== -1) {
        this.achievementData.selectedGroupExhibitions[index] = { ...this.groupExhibitionToBeChanged };
      }
      //api ile datayı güncelle
      this.updateAchievement();

      this.isGroupExhibitionDetailVisible = false;
      this.groupExhibitionToBeChanged = {};
    },
    handleDeleteGroupExhibition(){
      //1. ilgili orderNo'ya sahip veriyi personalExhibition listesinden kaldır
      this.achievementData.selectedGroupExhibitions = this.achievementData.selectedGroupExhibitions.filter(
        item => item.orderNo !== this.groupExhibitionOrderNoToBeDeleted
      );

      //2. OrderNo'ya göre sırala
      this.achievementData.selectedGroupExhibitions = this.achievementData.selectedGroupExhibitions
        .sort((a, b) => a.orderNo - b.orderNo)
        .map((item, index) => ({
          ...item,
          orderNo: index + 1 // yeniden 1, 2, 3... diye numaralandır
        }));

      //3. update apisini çağır achievementData'yı gönder güncellensin
      this.updateAchievement();

      this.closeGroupExhibitionDeleteModal();
    },
    closeGroupExhibitionDeleteModal(){
      this.isGroupExhibitionDeleteConfimationVisible = false;
    },

    //Symposium
    openSymposiumaddModal(){
      this.isSymposiumAddVisible = true;
    },
    saveSymposiumOrder(){
      this.updateAchievement();
    },
    openSymposiumInfoModal(orderNo){
      this.symposiumToBeChanged = this.achievementData.symposiums.find(info => info.orderNo === orderNo);
      this.isSymposiumDetailVisible = true;
    },
    openSymposiumDeleteModal(orderNo){
      this.isSymposiumDeleteConfimationVisible = true;
      this.symposiumOrderNoToBeDeleted = orderNo;
    },
    addSymposium(){
      // 1. orderNo 0 olarak ayarlanır
      this.symposiumToBeChanged.orderNo = 0;

      // 2. Listeye en başa eklenir
      this.achievementData.symposiums.unshift({ ...this.symposiumToBeChanged });

      // 3. Tüm orderNo’lar 1'den başlayacak şekilde yeniden sıralanır
      this.achievementData.symposiums.forEach((item, index) => {
        item.orderNo = index + 1;
      });

      //api call
      this.updateAchievement();
      this.closeSymposiumaddModal();
    },
    closeSymposiumaddModal(){
      this.isSymposiumAddVisible = false;
      this.symposiumToBeChanged = {};
    },
    updateSymposiumInfo(){
      //this.symposiumToBeChanged bunu this.achievementData.symposiums içindeki değere geçir.
      const index = this.achievementData.symposiums.findIndex(item => 
        item.orderNo === this.symposiumToBeChanged.orderNo
      );

      if (index !== -1) {
        this.achievementData.symposiums[index] = { ...this.symposiumToBeChanged };
      }
      //api ile datayı güncelle
      this.updateAchievement();

      this.isSymposiumDetailVisible = false;
      this.symposiumToBeChanged = {};
    },
    closeSymposiumDetailModal(){
      this.isSymposiumDetailVisible = false;
      this.symposiumToBeChanged = {};
    },
    handleDeleteSymposium(){
      //1. ilgili orderNo'ya sahip veriyi symposium listesinden kaldır
      this.achievementData.symposiums = this.achievementData.symposiums.filter(
        item => item.orderNo !== this.symposiumOrderNoToBeDeleted
      );

      //2. OrderNo'ya göre sırala
      this.achievementData.symposiums = this.achievementData.symposiums
        .sort((a, b) => a.orderNo - b.orderNo)
        .map((item, index) => ({
          ...item,
          orderNo: index + 1 // yeniden 1, 2, 3... diye numaralandır
        }));

      //3. update apisini çağır achievementData'yı gönder güncellensin
      this.updateAchievement();

      this.closeSymposiumDeleteModal();
    },
    closeSymposiumDeleteModal(){
      this.isSymposiumDeleteConfimationVisible = false;
    },

    //Fair
    openFairaddModal(){
      this.isFairAddVisible = true;
    },
    saveFairOrder(){
      this.updateAchievement();
    },
    openFairInfoModal(orderNo){
      this.fairToBeChanged = this.achievementData.fairs.find(info => info.orderNo === orderNo);
      this.isFairDetailVisible = true;
    },
    openFairDeleteModal(orderNo){
      this.isFairDeleteConfimationVisible = true;
      this.fairOrderNoToBeDeleted = orderNo;
    },
    addFair(){
      // 1. orderNo 0 olarak ayarlanır
      this.fairToBeChanged.orderNo = 0;

      // 2. Listeye en başa eklenir
      this.achievementData.fairs.unshift({ ...this.fairToBeChanged });

      // 3. Tüm orderNo’lar 1'den başlayacak şekilde yeniden sıralanır
      this.achievementData.fairs.forEach((item, index) => {
        item.orderNo = index + 1;
      });

      //api call
      this.updateAchievement();
      this.closeFairaddModal();
    },
    closeFairaddModal(){
      this.isFairAddVisible = false;
      this.fairToBeChanged = {};
    },
    updateFairInfo(){
      //this.fairToBeChanged bunu this.achievementData.fairs içindeki değere geçir.
      const index = this.achievementData.fairs.findIndex(item => 
        item.orderNo === this.fairToBeChanged.orderNo
      );

      if (index !== -1) {
        this.achievementData.fairs[index] = { ...this.fairToBeChanged };
      }
      //api ile datayı güncelle
      this.updateAchievement();

      this.isFairDetailVisible = false;
      this.fairToBeChanged = {};
    },
    closeFairDetailModal(){
      this.isFairDetailVisible = false;
      this.fairToBeChanged = {};
    },
    handleDeleteFair(){
      //1. ilgili orderNo'ya sahip veriyi fair listesinden kaldır
      this.achievementData.fairs = this.achievementData.fairs.filter(
        item => item.orderNo !== this.fairOrderNoToBeDeleted
      );

      //2. OrderNo'ya göre sırala
      this.achievementData.fairs = this.achievementData.fairs
        .sort((a, b) => a.orderNo - b.orderNo)
        .map((item, index) => ({
          ...item,
          orderNo: index + 1 // yeniden 1, 2, 3... diye numaralandır
        }));

      //3. update apisini çağır achievementData'yı gönder güncellensin
      this.updateAchievement();

      this.closeFairDeleteModal();
    },
    closeFairDeleteModal(){
      this.isFairDeleteConfimationVisible = false;
    },
    
    //Prize
    openPrizeaddModal(){
      this.isPrizeAddVisible = true;
    },
    savePrizeOrder(){
      this.updateAchievement();
    },
    openPrizeInfoModal(orderNo){
      this.prizeToBeChanged = this.achievementData.prizes.find(info => info.orderNo === orderNo);
      this.isPrizeDetailVisible = true;
    },
    openPrizeDeleteModal(orderNo){
      this.isPrizeDeleteConfimationVisible = true;
      this.prizeOrderNoToBeDeleted = orderNo;
    },
    addPrize(){
      // 1. orderNo 0 olarak ayarlanır
      this.prizeToBeChanged.orderNo = 0;

      // 2. Listeye en başa eklenir
      this.achievementData.prizes.unshift({ ...this.prizeToBeChanged });

      // 3. Tüm orderNo’lar 1'den başlayacak şekilde yeniden sıralanır
      this.achievementData.prizes.forEach((item, index) => {
        item.orderNo = index + 1;
      });

      //api call
      this.updateAchievement();
      this.closePrizeaddModal();
    },
    closePrizeaddModal(){
      this.isPrizeAddVisible = false;
      this.prizeToBeChanged = {};
    },
    updatePrizeInfo(){
      //this.prizeToBeChanged bunu this.achievementData.prizes içindeki değere geçir.
      const index = this.achievementData.prizes.findIndex(item => 
        item.orderNo === this.prizeToBeChanged.orderNo
      );

      if (index !== -1) {
        this.achievementData.prizes[index] = { ...this.prizeToBeChanged };
      }
      //api ile datayı güncelle
      this.updateAchievement();

      this.isPrizeDetailVisible = false;
      this.prizeToBeChanged = {};
    },
    closePrizeDetailModal(){
      this.isPrizeDetailVisible = false;
      this.prizeToBeChanged = {};
    },
    handleDeletePrize(){
      //1. ilgili orderNo'ya sahip veriyi prize listesinden kaldır
      this.achievementData.prizes = this.achievementData.prizes.filter(
        item => item.orderNo !== this.prizeOrderNoToBeDeleted
      );

      //2. OrderNo'ya göre sırala
      this.achievementData.prizes = this.achievementData.prizes
        .sort((a, b) => a.orderNo - b.orderNo)
        .map((item, index) => ({
          ...item,
          orderNo: index + 1 // yeniden 1, 2, 3... diye numaralandır
        }));

      //3. update apisini çağır achievementData'yı gönder güncellensin
      this.updateAchievement();

      this.closePrizeDeleteModal();
    },
    closePrizeDeleteModal(){
      this.isPrizeDeleteConfimationVisible = false;
    }




  }
}
</script>

<style scoped>
.container{
  width: 80vw;
  padding: 1%;
}

.catalog{
  display: flex;
  justify-content: center;
  
}

.bio{
  display: flex;
  flex-direction: column;
  padding-left: 40px;
  margin-top: 30px;
}

.saveBio{
  width: 80px;
  justify-self: center;
  align-self: center;
}

button{
    height: 40px;
    width: 100px;
    border-radius: 5%;
    font-size: 15px;
    border: none;
    cursor: pointer;
    margin: 20px;
    margin-left: 0;
}

.saveBtn{
    background: #17A2B8;
    color: aliceblue;
    height: 40px;
    border-radius: 5%;
    font-size: 15px;
}

#personal-exhibition-list{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 0.8%;
    background-color: rgb(172, 172, 172);
}

#group-exhibition-list{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 0.8%;
    background-color: rgb(172, 172, 172);
}

#symposium-list{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 0.8%;
    background-color: rgb(172, 172, 172);
}

#fair-list{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 0.8%;
    background-color: rgb(172, 172, 172);
}

#prize-list{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 0.8%;
    background-color: rgb(172, 172, 172);
}

.image-item{
    display: flex;
    height: 50px;
    margin-top: 15px;
    flex-direction: row;
    align-items: center;
    border-radius: 3%;
    justify-content: space-between;
    background-color: rgb(211, 211, 211);
}

.image-name{
    margin-left: 5px;
}

.image-button-group{
    width: 250px;
    display: flex;
    justify-content: right;
}

.image-info{
    margin-right: 40px;
}

.image-info button{
    background-color: #17A2B8;
    color: aliceblue;
}

.delete button{
    background-color: #DC3545;
    color: aliceblue;
    width: 50px;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.modal-actions button {
    margin: 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.modal-actions button:first-of-type {
    background: #e74c3c;
    color: white;
}

.modal-actions button:last-of-type {
    background: #bdc3c7;
}

/*DETAIL*/
.detail-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.detail-modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 650px;
    height: 450px;
    overflow: auto;
    display: flex;
    flex-direction: column;
}

.detail-modal-actions button {
    margin: 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.detail-modal-actions button:first-of-type {
    background: #17A2B8;
    color: aliceblue;
}

.detail-modal-actions button:last-of-type {
    background: #DC3545;
    color: aliceblue;
}
.detail-modal-content table{
    width: 100%; /* Tablonun genişliği modal içerisine yayılsın */
    border-collapse: collapse;
}

.detail-modal-content table tbody tr td{
    padding: 10px; /* Hücre içeriğine boşluk ekler */
    text-align: left; /* İçeriği sola hizalar */
    font-weight: 800;
}

/*ADD*/
.add-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.add-modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 650px;
    height: 350px;
    overflow: auto;
    display: flex;
    flex-direction: column;
}

.add-modal-actions button {
    margin: 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.add-modal-actions button:first-of-type {
    background: #17A2B8;
    color: aliceblue;
}

.add-modal-actions button:last-of-type {
    background: #DC3545;
    color: aliceblue;
}
.add-modal-content table{
    width: 100%; /* Tablonun genişliği modal içerisine yayılsın */
    border-collapse: collapse;
}

.add-modal-content table tbody tr td{
    padding: 10px; /* Hücre içeriğine boşluk ekler */
    text-align: left; /* İçeriği sola hizalar */
    font-weight: 800;
}
</style>